import PageShell from "@/components/PageShell";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";
import { pick } from "@/i18n/translations";
import { WhatsappCTA, NewsletterSection, LocationSection } from "@/pages/Home";
import { Heart, Leaf, ShieldCheck, Sparkles } from "lucide-react";

export default function About() {
    const { t, lang } = useLang();
    const { settings } = useSettings();
    const aboutText = pick(settings.about_text, lang) || t.about.body1;

    const pillars = [
        { Icon: Leaf, t: t.about.points[0] },
        { Icon: Heart, t: t.about.points[1] },
        { Icon: ShieldCheck, t: t.about.points[2] },
        { Icon: Sparkles, t: t.about.points[3] },
    ];

    return (
        <PageShell>
            <section className="relative bg-brand-green text-white overflow-hidden">
                <div className="absolute inset-0 grainy opacity-50" />
                <div className="container-x relative py-20 md:py-28">
                    <div className="eyebrow text-brand-yellow">{t.about.eyebrow}</div>
                    <h1 className="mt-4 font-display font-extrabold text-4xl md:text-6xl lg:text-7xl text-balance max-w-3xl">{t.about.title}</h1>
                    <p className="mt-6 text-lg text-white/80 max-w-2xl">{aboutText}</p>
                </div>
            </section>

            <section className="container-x py-20">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="relative">
                        <img src="https://images.pexels.com/photos/2101261/pexels-photo-2101261.jpeg" alt="Frische Auswahl" className="rounded-3xl shadow-2xl aspect-[4/5] object-cover w-full" />
                    </div>
                    <div>
                        <h2 className="font-display font-bold text-3xl md:text-4xl">{t.about.pointsTitle}</h2>
                        <p className="mt-4 text-brand-charcoal/75">{t.about.body2}</p>
                        <div className="mt-7 grid sm:grid-cols-2 gap-4">
                            {pillars.map(({ Icon, t: txt }, i) => (
                                <div key={i} className="card-clean p-5">
                                    <div className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-green text-brand-yellow"><Icon className="h-4 w-4" /></div>
                                    <div className="mt-3 text-sm text-brand-charcoal/85">{txt}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <LocationSection />
            <WhatsappCTA />
            <NewsletterSection />
        </PageShell>
    );
}
